import { useEffect } from "react";

const useOverflowObserver = () => {
  useEffect(() => {
    if (window.document) {
      const body = window.document.body;

      const observer = new MutationObserver(() => {
        body.style.touchAction = body.style.overflow === "hidden" ? "none" : "";
      });

      observer.observe(body, {
        attributes: true,
        attributeFilter: ["style"]
      });
    }
  }, []);
};

export default useOverflowObserver;
